import React from 'react';
import './App.css';

import Routes from './routes';

export default function App() {
    return (
        <Routes />
    );
}